import { Routes } from "@angular/router";
import { AuthComponent } from "./auth/auth.component";
import { OneShotComponent } from "./one-shot/one-shot.component";

export const routes: Routes = [
  {
    path: "auth/:idInstancia/:authToken",
    component: AuthComponent,
  },
  {
    path: "oneshot/:idInstancia/:authToken/:number",
    component: OneShotComponent,
  },
  {
    path: "oneshot/:idInstancia/:authToken",
    component: OneShotComponent,
  },
  {
    // Redireciona qualquer outra rota para uma tela de erro/vazia
    path: "**",
    component: AuthComponent,
  },
];
